var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mounted)?_c('div',{staticClass:"bm-privacy__modal"},[_c('div',{staticClass:"bm-privacy__modal__backdrop"}),_c('div',{staticClass:"bm-privacy__modal__container",class:{ show: _vm.opened },on:{"click":_vm.markEvent}},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }